import api from "../../../api";
import { createChartHistoryLoader } from "../../../utils/chartHistory";

const loadChartHistory = createChartHistoryLoader(params => {
  // Raw histories use five-minute buckets; include the whole overlap bucket
  // so a cursor cannot replace its first sample with a later one.
  const request = { ...params };
  if (request.since) request.since = new Date(Math.floor(Date.parse(request.since) / 300000) * 300000).toISOString();
  return api.getLocationRawEventsIndex(request);
});

export default {
  // async getDeviceEvents({ commit }, { deviceId, days, startDate, endDate }) {
  //   commit("REQUEST_DEVICE_EVENTS");
  //   commit("SET_LOADING", true, { root: true });
  //   try {
  //     commit(
  //       "SUCCESS_REQUEST_DEVICE_EVENTS",
  //       await api.getDeviceEvents({ deviceId, days, startDate, endDate })
  //     );
  //   } catch (err) {
  //     if (!err.ok && err.status === 401) {
  //       commit("TO_LOGIN", true, { root: true });
  //     }
  //     commit("FAILURE_REQUEST_DEVICE_EVENTS");
  //   } finally {
  //     commit("SET_LOADING", false, { root: true });
  //   }
  // },
  async getLocationRawEventsIndex({ commit, rootState }, obj) {
    commit("REQUEST_LOCATION_RAW_EVENTS_INDEX");
    commit("SET_LOADING", true, { root: true });
    try {
      if (obj.chart) {
        const user = rootState?.auth?.mySelf || {};
        const scope = JSON.stringify([user._id, user.data_access, rootState?.metadata_sync?.scopeKey]);
        const rows = await loadChartHistory(obj, scope);
        commit("SUCCESS_REQUEST_CHART_HISTORY");
        return rows;
      }
      const response = await api.getLocationRawEventsIndex(obj);
      commit("SUCCESS_REQUEST_LOCATION_RAW_EVENTS_INDEX", response);
      return response.body;
    } catch (err) {
      if (!err.ok && err.status === 401) {
        commit("TO_LOGIN", true, { root: true });
      }
      if (obj.chart) {
        commit("FAILURE_REQUEST_CHART_HISTORY");
        throw err;
      }
      commit("FAILURE_REQUEST_LOCATION_RAW_EVENTS_INDEX");
      return [];
    } finally {
      commit("SET_LOADING", false, { root: true });
    }
  }

};
